import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { styled } from '@mui/material'
import { TableCell as BaseTableCell } from '@chilecompra/react-kit/components'

export const Content = styled('section')`
  font-size: 14px;
  line-height: 18px;
  overflow-x: auto;
  padding-bottom: 10px;
  padding-top: 16px;
  width: 100%;
`

export const Link = styled(({ bold, children, disabled, secondary, textDecoration, ...props }) => (
  <a {...props}>{children}</a>
))`
  align-items: center;
  color: ${props => (props.secondary || props.disabled ? props.theme.palette.gray[50] : props.theme.palette.blue[50])};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  display: inline-flex;
  font-size: 14px;
  font-weight: ${props => (props.bold ? 'bold' : '400')};
  pointer-events: ${props => (props.disabled ? 'none' : 'visible')};
  text-decoration: ${props => (props.textDecoration ? 'underline' : 'none')};

  &:hover {
    color: ${props => (props.secondary ? props.theme.palette.gray[35] : props.theme.palette.blue[35])};
    text-decoration: underline;
  }
`

export const LinkInternal = styled(RouterLink)`
  align-items: center;
  color: ${props => (props.secondary || props.disabled ? props.theme.palette.gray[50] : props.theme.palette.blue[50])};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  display: inline-flex;
  font-size: 14px;
  font-weight: ${props => (props.bold ? 'bold' : '400')};
  pointer-events: ${props => (props.disabled ? 'none' : 'visible')};
  text-decoration: ${props => (props.textDecoration ? 'underline' : 'none')};

  &:hover {
    color: ${props => (props.secondary ? props.theme.palette.gray[35] : props.theme.palette.blue[35])};
    text-decoration: underline;
  }
`

export const Separator = styled('hr')`
  border: 0;
  border-top: 1px solid ${props => props.theme.palette.custom.gray[75.5]};
  box-sizing: content-box;
  height: 0;
  margin: 24px 0;
  overflow: visible;
`

export const Strong = styled('strong')`
  font-weight: bold;
`

export const TableCell = styled(BaseTableCell)`
  &.MuiTableCell-root {
    padding: ${props => props.padding || '12px 9px 16px'} !important;

    &:first-child {
      padding: ${props => props.padding || '12px 9px 16px 0'} !important;
    }

    &:last-child {
      border-right: 0;
      padding: ${props => props.padding || '12px 0 16px 9px'} !important;
    }
  }
`
